import type { ConnectedAppUsageType } from "../db/schema";

import {
  CONNECTOR_USAGE_POLICIES,
  type ConnectorUsagePolicy,
} from "./connectorUsagePolicies";

type Surface = keyof ConnectorUsagePolicy["reporting"];

export type ConnectorUsageReportType<S extends Surface> = {
  [
    T in ConnectedAppUsageType
  ]: (typeof CONNECTOR_USAGE_POLICIES)[T]["reporting"][S] extends "rows"
    ? T
    : never;
}[ConnectedAppUsageType];

export function connectorUsageReportTypes<S extends Surface>(
  surface: S
): ConnectorUsageReportType<S>[] {
  return (
    Object.keys(CONNECTOR_USAGE_POLICIES) as ConnectedAppUsageType[]
  ).filter(
    (type) => CONNECTOR_USAGE_POLICIES[type].reporting[surface] === "rows"
  ) as ConnectorUsageReportType<S>[];
}

export function connectorUsageReportCounts<S extends Surface>(
  surface: S,
  rows: readonly { type: string }[]
): Record<ConnectorUsageReportType<S>, number> {
  const counts = new Map<string, number>();
  for (const row of rows) counts.set(row.type, (counts.get(row.type) ?? 0) + 1);
  return Object.fromEntries(
    connectorUsageReportTypes(surface).map((type) => [
      type,
      counts.get(type) ?? 0,
    ])
  ) as Record<ConnectorUsageReportType<S>, number>;
}

export const listedConnectorUsageTypes = connectorUsageReportTypes("list");
